import React, { ComponentProps, PropsWithChildren } from 'react'
import { Sticky } from 'react-sticky'

import { bemJoin } from 'bem-join'
import classnames from 'classnames'

import { MergeProps } from '@app/lib/types'

export type PageHeaderProps = MergeProps<
  ComponentProps<'div'>,
  {
    sticky?: boolean
  }
>

const b = bemJoin('lawyer-page')

export const PageHeader = ({
  children,
  className,
  sticky,
  ...rest
}: PropsWithChildren<PageHeaderProps>) => {
  if (sticky) {
    return (
      <Sticky topOffset={3}>
        {({ style, isSticky }) => (
          <div
            {...rest}
            style={style}
            className={classnames(
              b('header', {
                stuck: isSticky
              }),
              className
            )}
          >
            {children}
          </div>
        )}
      </Sticky>
    )
  }

  return (
    <div {...rest} className={classnames(b('header'), className)}>
      {children}
    </div>
  )
}
